import request from '@/axios/requestDelivery'

// A - 工程交底 - 03 - 获取排期方案
export function getSchedulingInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/disclose/getSchedulingInfo',
    method: 'post',
    data
  })
}
// A - 工程交底 - 0701 - 工期变更
export function alterationConstruction(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/disclose/alterationConstruction',
    method: 'post',
    data
  })
}
// A - 工程交底 - 0702 - 交底提交
export function saveDisclose(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/disclose/saveDisclose',
    method: 'post',
    data
  })
}
// A - 工程交底 - 07 - 确认开工
export function confirmStart(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/disclose/confirmStart',
    method: 'post',
    data
  })
}
// B-新建播报(施工变更)
export function saveAlteration(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/message/saveAlteration',
    method: 'post',
    data
  })
}
// B-获取施工变更详情
export function getAlterationInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/construction_alteration/getAlterationInfo',
    method: 'post',
    data
  })
}
// B-审核施工变更详情
export function auditAlteration(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/construction_alteration/auditAlteration',
    method: 'post',
    data
  })
}
// B-获取播报列表
export function getMessageList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/message/getMessageList',
    method: 'post',
    data
  })
}
